// extracted by mini-css-extract-plugin
module.exports = {"doctor_privacy_content":"doctorPrivacy_doctor_privacy_content__3NtUQ"};